import DialogStore from './DialogStore';
import PresentationStore from './PresentationStore';
import { IDialogStore, IPresentationStore, IRootStore, IUserStore } from './types';
import UserStore from './UserStore';

export default class Rootstore implements IRootStore {
    private _dialogStore: IDialogStore;
    private _userStore: IUserStore;
    private _presentationStore: IPresentationStore;
  
    constructor() {
        this._dialogStore = new DialogStore();
        this._userStore = new UserStore();
        this._presentationStore = new PresentationStore();
    }

    public get dialogStore(): IDialogStore {
        return this._dialogStore;
    }

    public get userStore(): IUserStore {
        return this._userStore;
    } 

    public get presentationStore(): IPresentationStore {
        return this._presentationStore;
    }
}